export const share: any = {};